import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MasterDataService } from '../../services/masterdata.service';
import { Session } from "../../models/Session";
import { CreateClientService } from "../../services/create-client.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from 'rxjs';
import {
  NgbModal, NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";
import { Router } from '@angular/router';

@Component({
    selector: 'app-create-organization',
    templateUrl: './create-organization.component.html',
    styleUrls: ['./create-organization.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreateOrganizationComponent implements OnInit {
  @Input() session: Session;
  @Input() dropdownData_Sectors: any = [];
  @Output() updateTable: EventEmitter<any> = new EventEmitter();
  @ViewChild('content', { static: true }) private content;
  addClientForm: FormGroup;
  dropdownData: any = [];
  masterData:any;
  clientProgramList: any;
  industryList:any;
  showLoader: boolean = false;
  sectorList:any;
  companyName: string = "";
  ParentAccountName: string = "";
  DunsID: any;
  ParentDunsId: any;
  ParentDunsErrorMsg: string = "";
  DunsErrorMsg: string = "";
  validDunsId = true;
  validParentDunsId = true;
  verifyCompanyRes :number = 0;
  disableIndustryNA = true;
  disableSectorNA = true;
  validForm = false;
  resultModalContent: string = "";
  isCompanyExists = false; 
  showNAFields = false;  //(n) check these
  accountHierarchyList: string[] = ['Parent', 'Subsidiary'];
  accountHierarchy: string = null;
  private subscription: Subject<void> = new Subject<void>();
  constructor(private masterDataService: MasterDataService, 
  private createClientService: CreateClientService, private modalService: NgbModal, private router: Router) { }

  ngOnInit() {
    this.addClientForm = new FormGroup({
      CompanyName: new FormControl('', Validators.required),
      clientProgram: new FormControl(null, Validators.required),
      DunsId: new FormControl('', Validators.required),
      sessionIndustry: new FormControl(null, Validators.required),
      sessionSector: new FormControl(null, Validators.required),
      accountHierarchy: new FormControl(null, Validators.required),
      ParentAccountName: new FormControl(null, Validators.required),
      ParentDunsId: new FormControl(null, Validators.required)
  });
  this.session = new Session();
  this.getSessionData();
  }

  getSessionData(): void {
    this.masterDataService.getMasterDataDetails().subscribe((res) => {
        this.dropdownData = JSON.parse(JSON.stringify(res));
        this.masterData = JSON.parse(JSON.stringify(res));
        
        this.clientProgramList = this.masterData.ClientPrograms;
        this.industryList = this.masterData.Industries;
        this.sectorList = this.masterData.Sectors;
      
        this.loadIndustryDropdown();
    });
  }

  loadIndustryDropdown(includeNA?): void {
    if (this.masterData && this.masterData.Industries.length > 0) {
        if (includeNA) {
            this.dropdownData.Industries = this.masterData.Industries.filter(
                (data) => !data.IsMDR && data.IsActive
            );
        } else {
            this.dropdownData.Industries = this.masterData.Industries.filter(
                (data) => !data.IsMDR && data.IsActive && !data.Name.includes("N/A")
            );
        }
    }
  }

  onFocusOutCompany(event): void {
    this.companyName = event?.target?.value;
  }
  onFocusOutParentCompany(event): void {
    this.ParentAccountName = event?.target?.value;
  }
  onClientChange(event): void {     
    this.session.clientProgram = event;
  }
  onaccountHierarchyChange(event): void {
    this.accountHierarchy = event;
    if (this.accountHierarchy === 'Parent') {
      this.addClientForm.get('ParentAccountName').clearValidators();
      this.addClientForm.get('ParentDunsId').clearValidators();
      this.addClientForm.get('ParentAccountName').setValue('');
      this.addClientForm.get('ParentDunsId').setValue('');
      this.validParentDunsId = true;
      this.ParentDunsErrorMsg = ""
    } else {
      this.addClientForm.get('ParentAccountName').setValidators(Validators.required);
      this.addClientForm.get('ParentDunsId').setValidators(Validators.required);
    }

    this.addClientForm.get('ParentAccountName').updateValueAndValidity();
    this.addClientForm.get('ParentDunsId').updateValueAndValidity();
  }

  onFocusOutDunsId(event): void {
    this.DunsID = event.target.value;
    if (this.DunsID.length < 9) {
        this.validDunsId = false;
        this.DunsErrorMsg = "Please enter valid DUNS"
    }
    else {
        this.validDunsId = true;
    }
  }
  onFocusOutParentDunsId(event): void {
    this.ParentDunsId = event.target.value;
    if (this.ParentDunsId.length < 9) {
      this.validParentDunsId = false;
      this.ParentDunsErrorMsg = "Please enter valid Parent DUNS"
    }
    else {
      this.validParentDunsId = true;
    }
  }
  industryChange(event): void {
    if (!this.dropdownData || !this.dropdownData.Sectors) { return; }
    this.dropdownData_Sectors = this.dropdownData.Sectors.filter(
        (sector) => sector.IndustryID == event
    ); 
    this.session.sessionSector = null;
    const item = this.dropdownData.Industries.find(
        (index) => index.ID == event
    );
    this.session.sessionIndustry = item ? event : null;
    this.disableIndustryNA = true;
    if (item && item.Name.includes("N/A")) {
        this.disableIndustryNA = false;
        this.session.sessionSector = this.dropdownData_Sectors[0].SectorID;
        this.onSectorChange(this.dropdownData_Sectors[0].SectorID);
    } else {
        this.disableSectorNA = true;
    }
  }

  onSectorChange(id): void {
    if (this.dropdownData_Sectors && this.dropdownData_Sectors.length > 0) {
        const item = this.dropdownData_Sectors.find(
            (index) => index.SectorID === id
        );
        this.disableSectorNA = true;
        if (item && item.SectorName.includes("N/A")) {
            this.disableSectorNA = false;
        }
        this.session.sessionSector = id;
    }
  }

  onSubmitVerifyCompany(event): void {
    this.showLoader = true;
    this.addClientForm.controls['CompanyName'].setValue(this.addClientForm.value.CompanyName.replace(/^\s+|\s+$/gm,''))
    this.isCompanyExists = false;
    this.validForm = true;    
    if (this.addClientForm.invalid || !this.validDunsId) {
      this.showLoader = false;
        return;
    }   
   const data = {
       Name: this.companyName,
       DunsID: this.DunsID
    }    
    this.createClientService
        .verifyCompany(data)
        .pipe(takeUntil(this.subscription))
        .subscribe((res) => {
          if(res){
            if (res == 1) {
                    this.showLoader = false;
                    this.verifyCompanyRes =  +res;
                    this.isCompanyExists = true;
                   
                }
            else if (res == 2) {
              const ngbModalOptions: NgbModalOptions = {
                    backdrop: 'static',
                    keyboard: false,
                    centered: true
                };
                    this.showLoader = false;
                    this.verifyCompanyRes = +res;
                    this.resultModalContent = 'Company/Organization with this name already exists. Are you sure you want to continue?	';
                this.modalService.open(this.content, ngbModalOptions);
                  }
                else if (res == 3) {
                    this.verifyCompanyRes = +res;
                    // this.resultModalContent = 'Company/Organization loaded successfully.';
                    this.onSubmitAddCompany("INSERT", this.addClientForm.value);
                    
                    
                }
          }
        });
}

onSubmitAddCompany(flag, values) {
  const data = {
      Name: values.CompanyName,
      ClientProgramID: values.clientProgram,
      DunsID: values.DunsId,
      IndustryID: values.sessionIndustry,
      SectorID: values.sessionSector,
      ParentAccountDunsID: values.ParentDunsId,
      ParentAccountName: values.ParentAccountName,
      AccountHierarchy: values.accountHierarchy,
      Flag: "INSERT"
  }
  this.showLoader = true;
  this.createClientService
      .saveData(data)
      .pipe(takeUntil(this.subscription))
      .subscribe((res) => {
          if (res) {
              this.showLoader = false;
              if (flag === "UPDATE") {
                  this.verifyCompanyRes = 3;
                 
              }
              this.reDirectToSearch();              
          }
      });
  this.showLoader = false;


}
clearData(): void {
  this.addClientForm.reset();
  this.validForm = false;
  this.isCompanyExists = false;
}

reDirectToSearch(): void {
  this.clearData();
  this.router.navigate(['/searchOrganization'])
}

acceptAlphanumericInput(event): boolean {
  return ((!event.shiftKey && event.charCode >= 48 && event.charCode <= 57) || (event.charCode >= 65 && event.charCode <= 90) 
  || (event.charCode >= 97 && event.charCode <= 122)) ? true : false;
}

  

}
